<script>
import baseMixin from '@mixins/baseMixin'
import TheProfileDropdown from '@/components/layout/the-profile-dropdown.vue'
import PendingFeedbackPanel from '@components/layout/pending-feedback-panel.vue'
import TheOwnerDetails from '@components/general/the-owner-details.vue'

export default {
  name: 'TheTopBar',
  components: {
    TheProfileDropdown,
    PendingFeedbackPanel,
    TheOwnerDetails,
  },
  mixins: [baseMixin],
  props: {
    hideDrawer: {
      type: Boolean,
    },
  },
  methods: {
    toggleDrawer() {
      this.$emit('toggleDrawer')
    },
  },
}
</script>

<template>
  <v-app-bar
    app
    clipped-left
    color="white"
    flat
    height="72"
    class="cl-app-bar py-0"
  >
    <!--  -->
    <v-app-bar-nav-icon
      v-if="!hideDrawer"
      class="d-lg d-md d-sm d-sx"
      @click="toggleDrawer"
    />

    <v-spacer />

    <PendingFeedbackPanel class="ml-2" />

    <TheOwnerDetails />

    <TheProfileDropdown class="ml-2" />
  </v-app-bar>
</template>

<style lang="scss" scoped>
.cl-app-bar {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
}
</style>
